import request from '@/utils/request'

export function getMatchList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchList.json',
    method: 'post',
    data
  })
}

export function createMatch(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateMatch.json',
    method: 'post',
    data
  })
}

export function getMatchInfo(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatch.json',
    method: 'post',
    data
  })
}

export function updateMatchInfo(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMatch.json',
    method: 'post',
    data
  })
}

export function deleteMatch(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMatchStatus.json',
    method: 'post',
    data
  })
}

export function createMatchGroup(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateMatchGroup.json',
    method: 'post',
    data
  })
}

export function getMatchGroupList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchGroupList.json',
    method: 'post',
    data
  })
}

export function getMatchGroup(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchGroup.json',
    method: 'post',
    data
  })
}

export function updateMatchGroup(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMatchGroup.json',
    method: 'post',
    data
  })
}

export function createTeam(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateTeam.json',
    method: 'post',
    data
  })
}

export function getMatchGroupTeamList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchGroupTeamList.json',
    method: 'post',
    data
  })
}

export function getValidOrgList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetOrganizationList.json',
    method: 'post',
    data
  })
}

export function adminGetOrganizationCoachList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationCoachList.json',
    method: 'post',
    data
  })
}

export function getCoachList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetCoachList.json',
    method: 'post',
    data
  })
}

export const matchStateList = [
  { value: '', label: '全部' },
  { value: 0, label: '正常' },
  { value: -1, label: '禁用' }
]

export const auditStatus = [
  { value: '', label: '全部' },
  { value: 0, label: '审核中' },
  { value: 1, label: '未通过' },
  { value: 2, label: '通过' }
]

export const createTeamStatus = [
  { value: '', label: '全部' },
  { value: 0, label: '正常' },
  { value: -1, label: '禁用' }
]

export const role = [
  { value: 0, label: '普通队员' },
  { value: 1, label: '副队' },
  { value: 2, label: '领队' },
  { value: 3, label: '队长' }
]

export function getGroupTeam(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGroupTeam.json',
    method: 'post',
    data
  })
}

export function getOrganizationPlayerList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetOrganizationPlayerList.json',
    method: 'post',
    data
  })
}

export function adminAddTeamPlayers(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddTeamPlayers.json',
    method: 'post',
    data
  })
}

export function updateTeam(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateTeam.json',
    method: 'post',
    data
  })
}

export function adminDeleteTeamPlayers(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteTeamPlayers.json',
    method: 'post',
    data
  })
}

export function getOrganizationCoachList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationCoachList.json',
    method: 'post',
    data
  })
}

export function deleteMatchGroup(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteMatchGroup.json',
    method: 'post',
    data
  })
}

export function getGroupStageList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGroupStageList.json',
    method: 'post',
    data
  })
}

export function getGameList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGameList.json',
    method: 'post',
    data
  })
}

export function createWeeks(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateWeeks.json',
    method: 'post',
    data
  })
}

export function getGroupWeekList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGroupWeekList.json',
    method: 'post',
    data
  })
}

export function createStages(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateStages.json',
    method: 'post',
    data
  })
}

export function updateStage(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateStage.json',
    method: 'post',
    data
  })
}

export function updateWeek(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateWeek.json',
    method: 'post',
    data
  })
}

export function deleteWeek(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteWeek.json',
    method: 'post',
    data
  })
}

export function deleteStage(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteStage.json',
    method: 'post',
    data
  })
}

export function createGame(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateGame.json',
    method: 'post',
    data
  })
}

export function GetGame(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetGame.json',
    method: 'post',
    data
  })
}

export function deleteGame(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteGame.json',
    method: 'post',
    data
  })
}

export function updateGame(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGame.json',
    method: 'post',
    data
  })
}

export function adminGetMatchRefereeStatsList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchRefereeStatsList.json',
    method: 'post',
    data
  })
}

export function exportRefereeData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportRefereeData.json',
    method: 'post',
    data
  })
}

export function exportMatchRefereeData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportMatchRefereeData.json',
    method: 'post',
    data
  })
}

export function exportOutMatchRefereeData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportOutMatchRefereeData.json',
    method: 'post',
    data
  })
}
export function exportOldMatchRefereeData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportOldMatchRefereeData.json',
    method: 'post',
    data
  })
}

// 外部赛事
export function adminCreateOutMatch(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateOutMatch.json',
    method: 'post',
    data
  })
}

export function adminCreateOldMatch(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateOldMatch.json',
    method: 'post',
    data
  })
}

export function adminGetMatchList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetMatchList.json',
    method: 'post',
    data
  })
}

export function getClientMatchList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMatchList.json',
    method: 'post',
    data
  })
}

export function getClientGroupList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetMatchGroupList.json',
    method: 'post',
    data
  })
}

export function getClientStageList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetGroupStageList.json',
    method: 'post',
    data
  })
}

export function adminGetOutMatchRefereeStatsList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOutMatchRefereeStatsList.json',
    method: 'post',
    data
  })
}

export function adminAddOutGameOffice(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddOutGameOffice.json',
    method: 'post',
    data
  })
}
export function adminAddRefereeOutGameOffices(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminAddRefereeOutGameOffices.json',
    method: 'post',
    data
  })
}
export function adminGetRefereeOutGameOffices(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeOutGameOffices.json',
    method: 'get',
    params
  })
}

export function adminGetRefereeStatsList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeStatsList.json',
    method: 'get',
    params
  })
}

export function exportMatchData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportMatchData.json',
    method: 'post',
    data
  })
}

export function exportTeamData(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportTeam.json',
    method: 'post',
    data
  })
}

export function exportGroupTeams(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportGroupTeams.json',
    method: 'post',
    data
  })
}

export function exportCoaches(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportCoaches.json',
    method: 'post',
    data
  })
}

export function exportInFieldReferees(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportInFieldReferees.json',
    method: 'post',
    data
  })
}

export function exportOutFieldReferees(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportOutFieldReferees.json',
    method: 'post',
    data
  })
}

export function exportOrganizations(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportOrganizations.json',
    method: 'post',
    data
  })
}

export function exportPlayers(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportPlayers.json',
    method: 'post',
    data
  })
}

export function AdminGetOutGame(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOutGame.json',
    method: 'get',
    params
  })
}

export function AdminGetOutGameList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOutGameList.json',
    method: 'get',
    params
  })
}
export function AdminDeleteOutGame(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteOutGame.json',
    method: 'post',
    data
  })
}

export function adminUpdateMatchGroupTeam(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMatchGroupTeam.json',
    method: 'post',
    data
  })
}

export function getMatchGroupTeamResultList(params) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/groups/results',
        method: 'get',
        params
    }) 
}

export function updateMatchGroupTeamResult(params, data) {
    params = Object.assign(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/match_group_team/',
        method: 'put',
        data,
        params
    }) 
}

export function getImportGroupTeamUrl(groupId) {
     return process.env.BJH_STATS_API + '/api/rpes/odl_group_team_player/?groupId=' + groupId + '&batch=' + (new Date).getTime() + '&format=xlsx&keepPostData=true&accessKey=bjh-admin-rpes'
}

export function getImportGroupTeamTemplateUrl() {
     return process.env.BJH_STATS_API + '/api/res/template/group_team_template.xlsx?accessKey=bjh-admin-rpes'
}

export function getMatchPlayerTotal() {
    const params = {accessKey: 'bjh-admin-rpes', ts: Math.random()}
     return request({
        url: process.env.BJH_STATS_API + '/api/rpes/match/player/total',
        method: 'get',
        params
    }) 
}